<template>
  <div class="detail_box">
    <!-- 标题 -->
    <div class="title" v-text="detailInfo.title"></div>
    <!-- 媒体号 -->
    <div class="we-media" v-if="detailInfo.selfChannelOrNot">
      <div class="portrait">
        <img :src="lconImagePath" @click="toMedia(detailInfo.reporterFreJSON.id)" />
      </div>
      <div class="text">
        <div class="nick" v-text="name" @click="toMedia(detailInfo.reporterFreJSON.id)"></div>
        <div class="created">
          <span v-text="detailInfo.publishTime.slice(0, 16)"></span>
          <!-- <span class="readnum" v-if="detailInfo.isShowPlayCount">阅读量：<span v-text="detailInfo.playCount"></span></span> -->
        </div>
        <span :class="{ attention: true, attentioned: subscribed }" @click="onAttentionClick($event)"
          v-text="attentionStr"></span>
      </div>
    </div>
    <!-- 非媒体号 -->
    <div class="junior clearfix" v-else>
      <span class="source" v-text="detailInfo.source"></span>
      <span class="time" v-text="detailInfo.publishTime.slice(0, 16)"></span>
      <!-- <span class="readnum" v-if="detailInfo.isShowPlayCount">阅读量：<span v-text="detailInfo.playCount"></span></span> -->
    </div>
    <!-- 详情内容 -->
    <div :class="{content:true,juniorq:detailInfo.isAffiche==1}" v-html="detailInfo.text"></div>
    <div class="leave" v-if="detailInfo.isAffiche==1"></div>
    <!-- 记者(作者) -->
    <div class="reporter" v-text="'作者：' + detailInfo.reporter"
      v-if="!!detailInfo.reporter && detailInfo.reporter.length > 0"></div>
    <!-- <div class="dowon" @click="downloadPDF" v-if="this.detailInfo.afficheUrl">&gt;点击下载PDF文件&lt;</div> -->
    <div class="dowon" v-if="this.detailInfo.afficheUrl">
      <img @click="downloadPDF" :src="require('@/assets/images/pdf_download.png')" />
      <span @click="downloadPDF">下载pdf</span>
    </div>
    <!-- 来源 -->
    <div class="source" v-text="'来源：' + detailInfo.source" v-if="!!detailInfo.source && detailInfo.source.length > 0"></div>
    <!-- 责任编辑 -->
    <div class="editor" v-text="'责任编辑：' + detailInfo.editor" v-if="!!detailInfo.editor"></div>
    <!-- 实习编辑 -->
    <!-- <div class="editor" v-if="!!detailInfo.editorIntern" v-text="'实习编辑：' + detailInfo.editorIntern"></div> -->
    <div class="readnum" v-text="'阅读量：' + detailInfo.playCount" v-if="detailInfo.isShowPlayCount"></div>
    <!-- 标签 -->
    <div class="tag_list" v-if="tagList.length > 0">
      <ul class="clearfix">
        <li v-for="item in tagList" :key="item.id" v-text="'# ' + item"></li>
      </ul>
    </div>
    <!-- 点赞 -->
    <div class="praise_box" v-if="detailInfo.allowLikes != false && detailInfo.allowLikes != 0">
      <div :class="{ praise: true, praised: isLiked }" @click="onPraiseClick">
        <Icon iconClass="candle" v-if="isLiked == true && detail.likeType == '10'" />
        <Icon iconClass="pray" v-else-if="isLiked == true && detail.likeType == '11'" />
        <!-- <Icon iconClass="praise" v-else-if="isLiked == true" /> -->
        <van-icon name="like" v-else-if="isLiked == true" />
        <Icon iconClass="candle-o" v-if="isLiked == false && detail.likeType == '10'" />
        <Icon iconClass="pray-o" v-else-if="isLiked == false && detail.likeType == '11'" />
        <!-- <Icon iconClass="praise-o" v-else-if="isLiked == false" /> -->
        <van-icon name="like-o" v-else-if="isLiked == false" />
        <span v-text="'点赞' + topCount"></span>
      </div>
    </div>
    <div class="media_reporter_box">
      <!-- 记者号列表 -->
      <div class="news_media_list" v-if="!!reporterMediaList && reporterMediaList.length > 1">
        <div class="news_media_title"><span>对这篇文章有想法？跟我聊聊吧</span></div>
        <ul>
          <li class="media_item" v-for="item in reporterMediaList" :key="item.id">
            <div class="portrait"
              :style="{ backgroundImage: 'url(' + (item.lconImagePath == '' ? require('@/assets/images/user_default.png') : item.lconImagePath) + ')' }"
              @click="toMedia(item.id)"></div>
            <div class="name" @click="toMedia(item.id)">{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <div class="news_media" v-else-if="!!reporterMedia && JSON.stringify(reporterMedia) != '{}'">
        <div class="media_reporter" @click="toMedia(reporterMedia.id)">
          <div class="reporter_portrait">
            <img
              :src="reporterMedia.lconImagePath == '' ? require('@/assets/images/user_default.png') : reporterMedia.lconImagePath" />
          </div>
          <div class="reporter_info">
            <div class="reporter_name">
              <span class="name" v-text="reporterMedia.name"></span>
              <span class="sub_num">订阅数：<span v-text="reporterMedia.subscribeNum"></span></span>
            </div>
            <div class="reporter_intr" v-text="reporterMedia.introduce"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jq from "jquery";
import { mapState } from "vuex";
import { deepClone, addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
import mediaApi from "@/api/apis/media.js";
export default {
  name: "Detail",
  props: {
    params: {
      type: Object,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    },
    reporterMedia: {
      type: Object,
      default: null,
    },
    reporterMediaList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      detailInfo: null,
      subscribed: false, // 是否已订阅
      attentionStr: "+ 订阅",
      topCount: 0, //点赞数
      isLiked: false,
      isUpdated: false,
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId", "nodeCode"]),
    /* 媒体号头像 */
    lconImagePath() {
      let channelJson = this.detailInfo.channelJson;
      if (channelJson) {
        return channelJson.lconImagePath;
      }
    },
    /* 媒体号名称 */
    name() {
      let channelJson = this.detailInfo.channelJson;
      if (channelJson) {
        return channelJson.name;
      }
    },
    /* 标签 */
    tagList() {
      let tagList = this.detailInfo.tags;
      if (tagList) {
        return tagList.split(/,|，|\s+/);
      } else {
        return [];
      }
    },
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        this.detailInfo = deepClone(newValue);
        if (!!this.detailInfo) {
          this.getThumbsUpStatus();
        }
      },
      deep: true,
    },
  },
  methods: {
    /* 跳转版权声明 */
    toCopyright() {
      if (!!this.headerHidden) {
        this.$router.push({
          path: "/copyright",
          query: {
            client: 1
          },
        });
      } else {
        this.$router.push("/copyright");
      }
    },
    /* 增加积分 */
    addScore(code) {
      let jf_params = {};
      if (code == "dy") {
        jf_params = {
          code: 'dy', // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
          description: "订阅", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
          // contentType: this.mediaParams.contentType, // 非必传，稿件的type
          // contentId: this.detailInfo.selfChannelId, // 非必传，稿件的id
          // contentName: this.detailInfo.selfChannelName, // 非必传，稿件的标题
        }
      } else if (code == "dz") {
        jf_params = {
          code: 'dz', // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
          description: "点赞", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
          contentType: this.params.contentType, // 非必传，稿件的type
          contentId: this.params.contentId, // 非必传，稿件的id
          contentName: this.detailInfo.title, // 非必传，稿件的标题
        }
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 获取订阅信息 */
    getSubscription() {
      var _this = this;
      var params = {
        id: _this.detailInfo.selfChannelId,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .isSubscribe(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已订阅";
          } else {
            _this.subscribed = false;
            _this.attentionStr = "+ 订阅";
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 订阅 */
    subscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.detailInfo.selfChannelId,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .subscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = true;
            _this.attentionStr = "已订阅";
            _this.addScore('dy'); // 增加积分,订阅
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消订阅 */
    unSubscribeSelfMedia() {
      var _this = this;
      var params = {
        id: _this.detailInfo.selfChannelId,
        userId: _this.userInfo.id,
        nodeCode: _this.nodeCode,
      };
      mediaApi
        .unSubscribeSelfMedia(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.subscribed = false;
            _this.attentionStr = "+ 订阅";
            _this.$toast({
              message: "取消订阅成功",
              position: "center",
            });
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 订阅/取消订阅 */
    onAttentionClick(event) {
      if (!!this.userInfo) {
        /* 已订阅则取消订阅 */
        if (this.subscribed) {
          this.unSubscribeSelfMedia(); // 取消订阅
        } else {
          this.subscribeSelfMedia(); // 订阅
        }
      } else {
        this.$router.push("/login");
      }
    },
    /* 点击记者号，跳转记者号详情 */
    toMedia(id) {
      var q = {
        contentType: "we-media",
        id: id,
      }
      if (!!this.headerHidden) {
        q = Object.assign(q, { client: 1 });
      }
      this.$router.push({
        path: "/media_detail",
        query: q,
      });
    },
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.detailInfo.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.topCount = res.data.topCount;
            if (res.data.userLikes == 1) {
              _this.isLiked = true;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 点赞、取消点赞 */
    onPraiseClick() {
      var _this = this;

      var params = {
        contentType: _this.params.contentType,
        contentId: _this.detailInfo.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      if (_this.isLiked) {
        commApi
          .cancelThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.isLiked = false;
              _this.topCount--;
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        commApi
          .giveThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.isLiked = true;
              _this.topCount++;
              _this.addScore('dz'); // 增加积分,点赞
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    downloadPDF() {
      console.log(this.userInfo)
    
      if (!!this.userInfo) {
        window.open(this.detailInfo.afficheUrl)
      } else {
        this.$router.push("/login");
      }
      return
      // let _this = this
      var xhr = new XMLHttpRequest();
      xhr.open('GET', this.detailInfo.afficheUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var blobUrl = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = _this.detailInfo.title + '.pdf';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);

        }
      };
      xhr.onerror = function () {
        console.error('Error downloading PDF');
      };

      xhr.send();
    },
  },
  created() {
    this.detailInfo = deepClone(this.detail);
    if (!!this.detailInfo) {
      this.getThumbsUpStatus();
      if (!!this.userInfo && this.detailInfo.selfChannelOrNot) {
        this.getSubscription(); //获取订阅信息
      }
    }
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
  updated() {
    /** 处理正文中的段首占位空格 **/
    /* if (jq(".content").length > 0) {
      var nodes = jq(".content").get(0).childNodes;
      if (nodes) {
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].innerHTML = jq.trim(nodes[i].innerHTML);
        }
      }
    } */
    if (!this.isUpdated) {
      this.isUpdated = true;
      /* 处理正文中的内容内链点击 */
      jq(".content label[data-plugin-type='content']").each(function (i, lab) {
        lab.onclick = function (obj) {
          var id = obj.currentTarget.getAttribute("data-id");
          var originalId = obj.currentTarget.getAttribute("data-original-id");
          var contentType = obj.currentTarget.getAttribute("data-content-type");
          var n = window.location.href.indexOf("#");
          var url = window.location.href.substring(0, n) + "#/index_share?contentType=" + contentType + "&contentId=" + id + "&id=" + originalId;
          window.open(url, "_blank");
        };
      });
      /* 处理正文中的活动内链点击 */
      jq(".content label[data-content-type='1']").each(function (i, lab) {
        lab.onclick = function (obj) {
          var id = obj.currentTarget.getAttribute("data-id");
          var n = window.location.href.indexOf("#");
          var url = window.location.href.substring(0, n) + "#/index_share?contentType=1&activityId=" + id;
          window.open(url, "_blank");
        };
      });
      /* 处理正文中的广告内链点击 */
      jq(".content label[data-content-type='8']").each(function (i, lab) {
        lab.onclick = function (obj) {
          var id = obj.currentTarget.getAttribute("data-id");
          var n = window.location.href.indexOf("#");
          var url = window.location.href.substring(0, n) + "#/index_share?contentType=8&contentId=" + id;
          window.open(url, "_blank");
        };
      });
      /** 强制处理图片、表格、内链 **/
      jq(".content img, .content table").each(function (i, elem) {
        if (elem.getAttribute("data-plugin-type") == "video") {
          return true
        }
        elem.style.maxWidth = "100%";
        elem.style.margin = "0 auto";
        elem.style.height = "auto";
        // elem.style.margin = "0";
      });
      /** 处理正文视频（兼容旧版） **/
      jq("section[data-plugin-type='video']").each(function (i, section) {
        var url = "";
        var program = JSON.parse(jq(section).find("img").get(0).getAttribute("data-value"));
        if (program && program.video && program.video.streamList && program.video.streamList.length > 0) {
          var stream = program.video.streamList[0];
          for (var s = 0; s < program.video.streamList.length; s++)
            if (program.video.streamList[s].isDefault == 1)
              stream = program.video.streamList[s];
          url = stream.url;
        }
        jq(section).find("img").before("<video controls src='" + url + "'></video>");

        if (jq(section).find("div").length == 0) {
          jq(section).append("<div class='video_play_btn'></div>");
        } else {
          jq(section).find("div").replaceWith("<div class='video_play_btn'></div>");
        }
        jq(section).find(".video_play_btn").unbind("click").bind("click", function (event) {
          /** 点击播放视频 **/
          jq(this).parent().find("img").css("display", "none");
          jq(this).parent().find(".video_play_btn").css("display", "none");
          jq(this).parent().find("video").css("display", "block");
          jq(this).parent().find("video").get(0).play();
        });
        jq(section).find("video").get(0).onended =
          jq(section).find("video").get(0).onerror =
          jq(section).find("video").get(0).onpause =
          function () {
            jq(section).find("img").show();
            jq(section).find("div").show();
            jq(section).find("video").hide();
          }
        jq(section).find("video").get(0).onplay =
          jq(section).find("video").get(0).onplaying =
          function () {
            jq(section).find("img").hide();
            jq(section).find("div").hide();
            jq(section).find("video").show();
          }
      });
      jq("section[data-plugin-type]").css("text-indent", "0");
      jq("section[data-plugin-type]").find("center").css("text-indent", "0");

      /** 处理iframe **/
      jq("iframe.tencent_video").each(function (i, elem) {
        jq(elem).width("100%")
        let width = jq(elem).width()
        let height = width * 0.5685
        jq(elem).height(height)
      })
    }
  }
};
</script>
<style scoped lang="scss">
.detail_box {
  margin-bottom: 16px;

  /* 标题 */
  .title {
    font-size: 24px;
    line-height: 34px;
    font-weight: bold;
    padding-top: 15px;
    padding-bottom: 0;
    color: #1a1a1a;
  }

  /* 来源，时间，阅读量 */
  .junior {
    height: 42px;
    padding-top: 10px;
    overflow: hidden;
    color: #646464;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      line-height: 32px;
      color: #646464;

      &.source {
        color: #646464;
      }

      &.time {
        float: right;
      }

      /* &.readnum {
        margin-left: 10px;
      } */
    }
  }

  /* 记者号：头像、来源，时间，阅读量 */
  .we-media {
    position: relative;
    display: flex;
    height: 54px;
    padding: 8px 0 0 0;
    margin-top: 8px;

    .portrait {
      width: 38.4px;
      height: 38.4px;
      // border: white 1px solid;
      line-height: 38.4px;
      overflow: hidden;
      background-image: url(~@/assets/images/user_default.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border: 1px solid #fff;
      border-radius: 100%;
      display: flex;
      justify-content: center;

      img {
        object-fit: cover;
        min-width: 100%;
        min-height: 100%;
      }
    }

    .text {
      position: relative;
      width: 100%;
      overflow: hidden;
      flex: 1;
      line-height: 20px;
      padding: 0 6px;

      .nick {
        color: #242424;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 20px;
      }

      .created {
        color: #b8b3ad;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        span {
          font-family: "Microsoft YaHei";
          /* &.readnum {
            margin-left: 10px;
          } */
        }
      }

      .attention {
        position: absolute;
        right: 0;
        top: 10px;
        padding: 0px 8px;
        line-height: 22px;
        background: #fff;
        border: 1.5px solid #318bff;
        border-radius: 5px;
        color: #318bff;
        font-size: 12px;
        cursor: pointer;

        &.attentioned {
          border-color: #b5b5b5;
          color: #b5b5b5;
        }
      }
    }
  }

  /* 内容 */
  .content {
    padding-top: 5px;
    padding-bottom: 10px;
    color: #2d2d2d;
    &.juniorq{
      text-align: justify;
    }
    // 针对135编辑器特殊处理
    .block-inner[data-inner-name="135editor-spread"] {
      overflow: hidden;
    }

    /deep/.block-inner[data-inner-name="135editor-spread"] {
      overflow: hidden;
    }

    * {
      max-width: 100%;
      white-space: normal;
      word-break: break-all;
    }

    /deep/p {
      margin: 0;
      padding: 7px 0;
      line-height: 30px;
      font-size: 18px;
      // text-indent: 2em;
      word-break: break-word;

      // text-align: justify;
      * {
        text-indent: 0 !important;
      }
    }

    /deep/video {
      display: block;
      max-width: 100% !important;
      margin: 0 auto !important;
      padding: 6px 0;
    }

    /deep/img {
      display: block;
      max-width: 100% !important;
      margin: 0 auto !important;
      padding: 6px 0;
    }

    /deep/.video_play_btn {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: url(~@/assets/images/icon_video_play.png) center no-repeat;
    }

    /deep/section[data-plugin-type="video"] video {
      margin: 0 !important;
      max-width: 100%;
      height: auto;
      display: none;
    }
    /deep/table{
      max-width:100%;
      p{
        word-break: break-all;
      }
    }
    /deep/td, /deep/th {
      padding: 5px 10px;
      border: 1px solid #DDD;
    }
  }

  /* 编辑 */
  .reporter,
  .source,
  .editor {
    margin-top: 4px;
    color: #c1c1c1;
    font-size: 14px;
    font-weight: 500;
  }

  .readnum {
    margin-top: 4px;
    color: #c1c1c1;
    font-size: 14px;
    font-weight: 500;
    text-align: right;
  }
  .leave{
    height: 30px;
  }
  .dowon {
    color: #ff5562;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 600;
  }

  .line {
    padding-top: 15px;
    width: 100%;
    border-bottom: 1px solid #ececec;
  }

  /* 标签 */
  .tag_list {
    padding-top: 5px;

    li {
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      border: 1px solid #f1f1f1;
      /* box-shadow: 3px 3px 5px #ddd, -1px -1px 6px #ddd; */
      margin-right: 10px;
      margin-top: 10px;
      line-height: 24px;
      color: #777777;
      font-size: 14px;
    }
  }

  /* 点赞 */
  .praise_box {
    position: relative;
    width: 100%;
    padding: 15px 0;
    text-align: center;

    .praise {
      height: 42px;
      width: 154px;
      margin: 8px auto 0;
      line-height: 42px;
      background: #f6f6f6;
      color: #8e8e8e;
      text-align: center;
      font-size: 15px;
      -webkit-border-radius: 21px;
      -moz-border-radius: 21px;
      border-radius: 21px;
      box-shadow: #ddd 0px 4px 7px;

      &.praised {
        background-color: #e1edff;
        color: #318bff;
      }

      .van-icon {
        margin-right: 5px;
        font-size: 20px;
        vertical-align: text-bottom;
      }

      .tj-svg-icon {
        margin-right: 5px;
        font-size: 19px;
        vertical-align: -0.1em;
      }
    }
  }

  .media_reporter_box {
    padding-top: 20px;

    /* 记者号 */
    .news_media_list {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 16px;
      padding-bottom: 16px;
      border: 1px solid #f1f1f1;

      .news_media_title {
        position: absolute;
        left: 16px;
        top: -8px;
        z-index: 1;
        padding: 0 12px;
        background: #fff;
        font-size: 12px;
        color: #999;
      }

      ul {
        max-width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;
        z-index: 1;

        li {
          display: inline-block;
          margin: 5px 10px;
          text-align: center;

          .portrait {
            width: 45px;
            height: 45px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            border-radius: 50%;
            border: 1px solid #bebebe;
          }

          .name {
            margin-top: 10px;
            font-size: 12px;
          }
        }
      }
    }

    .news_media {
      padding-top: 16px;

      /deep/.media_reporter {
        display: flex;
        position: relative;
        padding: 18px 15px;
        background: #fff;
        border: 1px solid #f1f1f1;

        &::after {
          position: absolute;
          top: calc(50% - 0.8em);
          right: 10px;
          z-index: 2;
          width: 25.6px;
          height: 25.6px;
          content: "";
          background: url(~@/assets/images/arrow-right.png) no-repeat right center;
          background-size: 25.6px;
        }

        .reporter_portrait {
          position: relative;
          top: 2px;
          width: 64px;
          height: 64px;
          line-height: 64px;
          overflow: hidden;
          background-image: url(~@/assets/images/user_default.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          border: 2px solid #bebebe;
          border-radius: 100%;
          -webkit-border-radius: 100%;
          -moz-border-radius: 100%;
          display: flex;
          justify-content: center;

          img {
            object-fit: cover;
            min-width: 100%;
            min-height: 100%;
          }
        }

        .reporter_info {
          position: relative;
          width: calc(100% - 64px);
          margin-left: 15px;
          padding-right: 30px;

          .reporter_name {
            line-height: 24px;
            padding-bottom: 5px;

            .name {
              color: #101010;
              font-size: 16px;
              font-weight: bold;
            }

            .sub_num {
              position: relative;
              top: 0;
              float: right;
              font-size: 13px;
            }
          }

          .reporter_intr {
            display: -webkit-box;
            height: 45px;
            overflow: hidden;
            line-height: 22.5px;
            font-size: 13px;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            text-align: justify;
            color: #777;
          }
        }
      }
    }
  }
}
</style>